// Pago con Redsys a pantalla completa (Bizum).
//
// Redsys no permite Bizum dentro de un iframe (error SIS0476), así que la
// página entera se va a Redsys. Antes de salir guardamos qué se estaba pagando
// para que la pantalla de vuelta (/PagoRedsys/:transactionId/:result) sepa
// adónde llevar al cliente cuando el pago se confirme.

const STORAGE_KEY = 'ewu_redsys_pending'
const REDSYS_ACTIONS = [
  'https://sis.redsys.es/',
  'https://sis-t.redsys.es:25443/',
]

export function rememberRedsysRedirect({ transactionId, context, amount, batchId }) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      transactionId: String(transactionId),
      context: context || 'cart',
      amount: Number(amount) || null,
      // Lote del carrito que se paga (con «pagar antes de pedir»).
      batchId: batchId ? String(batchId) : null,
      startedAt: Date.now(),
    }))
  } catch {
    // Sin almacenamiento la vuelta funciona igual; solo se pierde el destino.
  }
}

export function readRedsysRedirect(transactionId) {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
    if (value && (!transactionId || value.transactionId === String(transactionId))) return value
  } catch {
    // Dato corrupto o almacenamiento bloqueado.
  }
  return null
}

export function clearRedsysRedirect() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Nada que limpiar.
  }
}

export function submitRedsysFormFullPage(action, fields) {
  if (!REDSYS_ACTIONS.some(prefix => String(action || '').startsWith(prefix))) {
    throw new Error(`Destino de pago Redsys no válido: ${action}`)
  }
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = action
  form.target = '_self'
  form.style.display = 'none'
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })
  document.body.appendChild(form)
  form.submit()
}
